import { req, reqPost } from './axiosFun';
const BASE_URL = "";

/**
 * 股东管理
 **/
// 获取全部股东（含累计分红）
export const shareHolderList = () => { return req('get', BASE_URL + "/api/shareholder/getAllShareHolders", null) };
// 保存股东
export const shareHolderSave = (params) => { return reqPost(BASE_URL + "/api/shareholder/saveShareHolder", params) };
// 删除股东
export const shareHolderDelete = (params) => { return reqPost(BASE_URL + "/api/shareholder/delete", { ids: params }) };

/**
 * 股东分红
 **/
// 发起分红
export const dividendDistribute = (params) => { return reqPost(BASE_URL + "/api/dividend/distribute", params) };
// 分页查询分红明细
export const dividendRecordPage = (params) => { return reqPost(BASE_URL + "/api/dividend/queryDividendRecordPage", params) };
// 按股东汇总累计分红
export const dividendSummary = () => { return req('get', BASE_URL + "/api/dividend/summaryByShareholder", null) };



// WEBPACK FOOTER //
// ./src/api/shareholderMG.js